module.exports = __webpack_public_path__ + "img/nutra.17c8718f.svg";